import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  PortfolioManagerComponent,
  type IWalletDialogResponse,
} from 'src/app/components/entity-manager/portfolio-manager/portfolio-manager.component';
import {
  ConfirmationDialogComponent,
  ConfirmDialogResultType,
} from 'src/app/shared/components/modals/confirmation-dialog/confirmation-dialog.component';
import type { WalletResponseDto } from 'src/generated-sources/openapi/wallet-service/wallet';
import { DELETE_WALLET_TEXTS } from './wallet-details.constants';

@Injectable({ providedIn: 'any' })
export class WalletDetailsDialogService {
  private readonly dialog = inject(MatDialog);

  openDeleteConfirmation(walletName: string): Observable<ConfirmDialogResultType> {
    return this.dialog
      .open(ConfirmationDialogComponent, {
        data: {
          title: DELETE_WALLET_TEXTS.title(),
          message: DELETE_WALLET_TEXTS.message(walletName),
          confirmButton: {
            text: DELETE_WALLET_TEXTS.confirmButtonText(),
            style: 'danger',
            icon: 'delete_outlined',
          },
        },
      })
      .afterClosed();
  }

  openEditWalletDialog(wallet: WalletResponseDto): Observable<IWalletDialogResponse | undefined> {
    return this.dialog.open(PortfolioManagerComponent, { data: wallet }).afterClosed();
  }
}
